/**
 * @file コンポーネント：スライダー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledSlider = styled.div`
    position: relative;
    height: 100%;

    &.is-covered {
        &::before {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: ${zIndex.sliderCover};
            width: 100%;
            height: 100%;
            content: "";
        }
    }

    &.is-open {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: fixed;
        top: 64px;
        left: 0;
        z-index: ${zIndex.sliderZoomContent};
        width: 100%;
        height: calc(100% - 64px);
        padding: 16px;
        background-color: rgba(0, 0, 0, 0.4);
    }
`;

export const StyledSliderArrow = styled.button`
    width: 32px;
    height: 100%;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #ffffff;
    font-size: 16px;

    > i {
        text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    }
`;

export const StyledSliderArrowInactive = styled(StyledSliderArrow)`
    pointer-events: none;
`;

export const StyledSliderArrowlist = styled.ul``;

export const StyledSliderArrowlistItem = styled.li`
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    z-index: ${zIndex.sliderArrow};
    height: 100%;
`;

export const StyledSliderArrowlistItemLeft = styled(StyledSliderArrowlistItem)`
    left: 0;
`;

export const StyledSliderArrowlistItemRight = styled(StyledSliderArrowlistItem)`
    right: 0;
`;

export const StyledSliderClose = styled.button`
    align-self: flex-end;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #ffffff;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
`;

export const StyledSliderContainer = styled.div`
    position: relative;
    overflow: hidden;
`;

export const StyledSliderContentlist = styled.ul`
    height: 100%;
    overflow: auto;
`;

export const StyledSliderContentlistItem = styled.li`
    display: none;

    &.is-current {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const StyledSliderDot = styled.button`
    width: 12px;
    height: 12px;
    padding: 0;
    border: none;
    border-radius: 50%;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    background-color: #acadae;
    line-height: 1;
`;

export const StyledSliderDotInactive = styled.button`
    width: 12px;
    height: 12px;
    padding: 0;
    border: none;
    border-radius: 50%;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    background-color: rgba(255, 255, 255, 0.87);
    line-height: 1;
    pointer-events: none;
`;

export const StyledSliderDotlist = styled.ul`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 12px;
`;

export const StyledSliderDotlistItem = styled.li`
    margin: 0 4px;
`;

export const StyledSliderZoom = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: ${zIndex.sliderZoomButton};
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #ffffff;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
`;
